import { useNavigate } from 'react-router-dom';
import ProfileDetailsModal from '@/pages/customer/home/components/profileDetailsModal/ProfileDetailsModal';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { PagePad } from '@/common/styles/shared.styles';
import MySoftiesGrid from './components/MySoftiesGrid/MySoftiesGrid';
import MySoftiesHeading from './components/MySoftiesHeading/MySoftiesHeading';
import { useMySofties } from './hooks/useMySofties';
import { MySoftiesView } from './MySofties.styles';

const MySofties = () => {
	const navigate = useNavigate();
	const t = useLanguageData('mySofties');
	const { persons, selectedProfile, setSelectedProfile, isLoading } = useMySofties();

	const handleCloseProfile = () => {
		setSelectedProfile(undefined);
	};

	return (
		<>
			{selectedProfile && (
				<ProfileDetailsModal
					profile={selectedProfile}
					onClose={handleCloseProfile}
				/>
			)}
			<MySoftiesView id="mineView" data-view="mine">
				<PagePad>
					<MySoftiesHeading
						titlePrefix={t.titlePrefix}
						titleHighlight={t.titleHighlight}
					/>
					<MySoftiesGrid
						persons={persons}
						isLoading={isLoading}
						createLabel={t.createSoftie}
						onCreateSoftie={() => navigate('/studio')}
						onSelectProfile={setSelectedProfile}
					/>
				</PagePad>
			</MySoftiesView>
		</>
	);
};

export default MySofties;
